// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_os-0";
export var discountCodeInput = "_os-1";